export class ColorPicker{


    static #LIST = []
	static get LIST(){
		return this.#LIST
	}

    pickerInput
    pickerContainer
    pickerText
    pickerColorBlock
    value

    static init(){
		const colorPickers = document.getElementsByClassName('color-picker-custom');
		for(let pickerCont of colorPickers){
			let picker = new ColorPicker(pickerCont)
			ColorPicker.#LIST.push(picker)
		}
        for(let pickerCont of colorPickers){
            pickerCont.remove()
        }
	}

    /**
     * @param {Element} parent 
     */
    constructor(parent){
        console.log(parent)
        let container = document.createElement('label')
        container.className="color-picker-cont"
        container.htmlFor=parent.id
        let cBlock = document.createElement('div')
        let textBlock = document.createElement('span')
        let input = document.createElement('input')
        input.type="color"
        input.id = parent.id
        if(parent.hasAttribute('data-value'))
            input.value = parent.getAttribute('data-value')
        input.className="color-picker-input"
        cBlock.className="color-picker-cblock"
        cBlock.style.backgroundColor=input.value
        textBlock.className="color-picker-text"
        textBlock.textContent = input.value
        container.append(input)
        container.append(cBlock)
        container.append(textBlock)
        parent.parentElement.insertBefore(container, parent)
        this.pickerInput = input
        this.pickerContainer = container
        this.pickerText = textBlock
        this.pickerColorBlock = cBlock
        this.value = input.value

        input.addEventListener('input',()=>{
            this.value = this.pickerInput.value
            this.pickerText.textContent = this.value
            this.pickerColorBlock.style.backgroundColor = this.value
        })
    }


    static getPicker(id){
        return this.#LIST.find(x=>x.pickerInput.id == id)
    }
}